import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m29.781 20-3.996 1.88 2.128 3.87-4.34-.83-.55 4.384L20 26.08l-3.023 3.224-.55-4.384-4.34.83 2.129-3.87L10.219 20l3.997-1.88-2.128-3.87 4.339.83.55-4.385L20 13.92l3.023-3.225.55 4.385 4.34-.83-2.128 3.87L29.78 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M20 26.087a6.087 6.087 0 1 0 0-12.174 6.087 6.087 0 0 0 0 12.174Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M16.956 20a4.36 4.36 0 0 0-.434.022c.005.843.31 1.614.814 2.214a6.099 6.099 0 0 1 1.176-1.947 4.324 4.324 0 0 0-1.556-.29Zm1.874 3.276a3.47 3.47 0 0 0 2.34 0c-.2-.782-.61-1.48-1.17-2.03a4.35 4.35 0 0 0-1.17 2.03Zm4.182-5.015a3.476 3.476 0 0 0-6.024 0A6.047 6.047 0 0 1 20 19.08a6.047 6.047 0 0 1 3.012-.819Zm-1.524 2.028a6.098 6.098 0 0 1 1.176 1.947c.503-.6.808-1.371.814-2.214a4.36 4.36 0 0 0-1.99.267Z"
}, null, -1), d = [
  n,
  a,
  c,
  s
];
function i(_, r) {
  return l(), e("svg", o, [...d]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
